import { API } from "@swivl-mono/api-helper";
import { Channel, SessionInterface } from "@swivl-mono/types";

import CallModel from "../../CallModel/Call.Model";
import { Member } from "../../Member/Member.Current";
import NotificationsModel from "../../Notifications/Notifications.Model";
import PendingUpdatesModel, { PendingUpdateType } from "../../Pending/Pending.Model";
import { UsersModel } from "../Users.Model";

export const UsersModelSessionMethods = {
  getSession: (sessionId: number): SessionInterface | undefined => {
    return UsersModel.state.sessions?.[sessionId];
  },

  sessionUpdated: (session: SessionInterface) => {
    const user = session.user ? [session.user] : undefined;
    if (session.escalation) {
      UsersModel.setUserSessionOrEscalation(user, [session], [session.escalation]);
    } else {
      UsersModel.setUserSessionOrEscalation(user, [session], undefined);
    }
  },

  takeoverConversationOnChannel: (userId: number, channel: Channel) => {
    PendingUpdatesModel.addPendingUpdate(PendingUpdateType.TAKING_OVER_ON_CHANNEL, channel);
    return API.Sessions.takeoverConversationOnChannel(Member.orgId!, userId, channel, Member.id!)
      .then((session) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.TAKING_OVER_ON_CHANNEL, channel);
        if (session.escalation) {
          console.log("PUF takeoverConversationOnChannel session with escalation:", { ...session });
          UsersModel.setUserSessionOrEscalation(undefined, [session], [session.escalation]);
        } else {
          console.log("PUF takeoverConversationOnChannel session without escalation:", session);
          UsersModel.setUserSessionOrEscalation(undefined, [session], undefined);
        }
        return session;
      })
      .catch((error) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.TAKING_OVER_ON_CHANNEL, channel);
        NotificationsModel.createToastNotification({ message: "Failed to take over the conversation. Please try again." });
      });
  },
  endTakeoverOfSession: (sessionId: number, escalationId?: number) => {
    PendingUpdatesModel.addPendingUpdate(PendingUpdateType.SESSION_ESCALATION, sessionId);
    return API.Sessions.endTakenOverSession(Member.orgId!, sessionId, Member.id!, escalationId)
      .then((returnData) => {
        const session = returnData.session;
        const escalation = returnData.escalation;
        console.log("ESS## endTakeoverOfSession session :", session, escalation);
        if (escalation) {
          UsersModel.setUserSessionOrEscalation(undefined, [session], [escalation]);
        } else {
          UsersModel.setUserSessionOrEscalation(undefined, [session], undefined);
        }
        if (session.channel === Channel.VOICE) {
          CallModel.endVoiceCallForSession(session);
        }
        setTimeout(() => {
          PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, sessionId);
        }, 250);
        return session;
      })
      .catch((error) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, sessionId);
        return Promise.reject(error);
      });
  }
};
